export const setDocumentLanguage = (language) => {
  const langValue = language?.VALUE || 'en';
  const dirValue = language?.isRTL ? 'rtl' : 'ltr';

  document.documentElement.lang = langValue;
  document.documentElement.dir = dirValue;
};